import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { RestApiService } from './rest-api.service';
import { apiConst } from '../consts/apiConsts';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {

  public dealerDistDetails = new BehaviorSubject<Array<any>>([]);
  public keycloakData=new BehaviorSubject<Array<any>>([]);
  public userId=new BehaviorSubject<Array<any>>([]);
  public defaultLanguage=new BehaviorSubject<Array<any>>([]);
  public downloadReportExcel = new BehaviorSubject<Array<any>>([]);
public currencyformatdetails = new BehaviorSubject<Array<any>>([]);

public position!: string;
public sessionStorage = {};
public sessionData = {};
public positions: BehaviorSubject<string> = new BehaviorSubject<string>("");
public userName:any=""


public userInfo=new BehaviorSubject<Array<any>>([]);
public userRole=new BehaviorSubject<Array<any>>([]);
public userType: BehaviorSubject<string> = new BehaviorSubject<string>("");
public isuserloaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


public selectedPositions: BehaviorSubject<any> = new BehaviorSubject<any>([]);



  constructor(private restService:RestApiService,private route : Router,
    private keyCloakService:KeycloakService) {
    
     }



public async getKeyCloackData(type:string){
if(!(this.getkeycloakDetails && this.getkeycloakDetails.length) || type=="New"){
  var kcArray:any = ""; //KeyCloakService.auth.authz.tokenParsed.realm_access;
  var rolesArray: string[] = kcArray.roles;
  return this.keycloakData.next([rolesArray]);
}
}
public get getkeycloakDetails(){
  return this.keycloakData.getValue();
}

public async getKeyCloackUserid(type:string){
  if(!(this.getkeycloakUserId && this.getkeycloakUserId.length) || type=="New"){
    var usernid:any = "" // KeyCloakService.auth.authz.tokenParsed.userid;
    return this.userId.next(usernid);
  }
  }
  public get getkeycloakUserId(){
    return this.userId.getValue();
  }

  public async getDefaultLanguage(type:string,lang:string){
    if(!(this.getDeftLanguage && this.getDeftLanguage.length) || type=="New"){
      var dftLanguage:any =lang;
      return this.defaultLanguage.next(dftLanguage);
    }
    }
    public get getDeftLanguage(){
      return this.defaultLanguage.getValue();
    }


  public converStrToDate(dt: string) {
    if (dt != null && dt !='') {
      const dte = new Date(dt.substring(0, 10));
      return dte;
    }
    return '';
  }


  getPosition(){
    return this.positions.asObservable();
  }

  changePosition(value :any){
    this.positions.next(value);
  }


  public async getKeyCloackRole(type:string){
    if(!(this.getkeycloakRole && this.getkeycloakRole.length) || type=="New"){
      return await  this.userRole.next(this.keyCloakService.getUserRoles())
    }
}
public get getkeycloakRole(){
    return this.userRole.getValue();
}
public async getKeyCloackUserInfo(type:string){  
  if(!(this.getkeycloakUserInfo && this.getkeycloakUserInfo.length) || type=="New"){
  return await  this.keyCloakService.getKeycloakInstance().loadUserInfo().then((tkn:any) => {
      this.userName = tkn?.name;
    return this.userInfo.next(tkn);
      });
  }
}
public get getkeycloakUserInfo(){
  return this.userInfo.getValue();
}

public setSelectedPosition(position:any,type:string){
if(!(this.getSelectedPosition && this.getSelectedPosition.length)||type=="New"){
  return this.selectedPositions.next(position);
}
}
public get getSelectedPosition(){
  return this.selectedPositions.getValue()
}

public setUserType(userType:any){
  return this.userType.next(userType)
}
public setisuserloaded(val:boolean){
return this.isuserloaded.next(val)
}
public get getisuserloaded(){
  return this.isuserloaded.getValue()
}
}
